import { Alert, Button, Form, message, Space, Tag } from "antd";
import Paragraph from 'antd/lib/typography/Paragraph';
import { useEffect, useState } from "react";
import { useForm } from "antd/lib/form/Form";
import { InviteService } from "../../Services/InviteService";
import { useAuth } from "../../Contexts/AuthContext";
import { getDateStringFromDate } from "../../Helpers/DateHelpers";
import { TextService } from "../../Services/TextService";
import { OneFrontHtmlEditor } from "../Forms/OneFrontHtmlEditor";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { EventMailDesign, eventMailDesign, getEventMailDesignError } from "./EventMailDesign";
import { EventMailActions } from "./EventMailActions";

const FOLDED_EMAIL_COUNT = 20;

export const ReminderForm = (props: any) => {
    const [form] = useForm();
    const [reminderText, setReminderText] = useState("" as any);
    const { user } = useAuth();
    const [reminderEmails, setReminderEmails] = useState([] as any[]);
    const [design, setDesign] = useState(undefined as eventMailDesign | undefined);
    const [showAllEmails, setShowAllEmails] = useState(false);
    const GetText = TextService.GetText;

    useEffect(() => {
        let noReplies: string[] = [];
        props.invites?.forEach((invite: any) => {
            if (invite.replyId == 0) {
                noReplies.push(invite.email);
            }
        });
        setReminderEmails(noReplies);
    }, [props]);

    const onReminderFinish = async (formValues: any) => {
        const designError = getEventMailDesignError(design);

        if (designError) {
            message.warning(GetText(designError));
            return;
        }

        const result = await InviteService.SendInviteReminder({
            message: reminderText,
            eventId: props.event.eventId,
            emails: reminderEmails,
            design: design
        });

        setReminderEmails([]);

        message.success(GetText("ReminderForm_RemindersSuccessMessage"));
    };



    return <>
        {user?.hasPaidSubscription ?
            <>
                {props.event.automaticReminder != null ? <i>{GetText("ReminderForm_AutomaticTurnedOnText")} {getDateStringFromDate(props.event.automaticReminder)}</i> : <i>{GetText("ReminderForm_AutomaticTurnedOffText")}</i>}<br></br><br></br>



                {props.invitesNoReply.length > 0 ?
                    <>
                        <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                            <Paragraph><span>{props.invitesNoReply.length} {GetText("ReminderForm_InvitesStillWithoutReply")}</span></Paragraph>
                        </Space>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onReminderFinish}
                            autoComplete="off"
                        >

                            {/* Everyone invited who hasn't replied is already on the list, so there is nothing to type
                                in; a person can be left out by removing the tag. */}
                            <Form.Item label={GetText("ReminderForm_SendRemindersToColumn")}>
                                <div style={{ textAlign: "left" }}>
                                    {/* A long list is folded, otherwise hundreds of addresses push the message far down. */}
                                    {(showAllEmails ? reminderEmails : reminderEmails.slice(0, FOLDED_EMAIL_COUNT)).map(email =>
                                        // A coloured tag: the app theme makes a plain tag black.
                                        <Tag key={email} color="blue" closable onClose={() => setReminderEmails(reminderEmails.filter(p => p !== email))} style={{ marginBottom: "6px" }}>{email}</Tag>)}
                                    {reminderEmails.length > FOLDED_EMAIL_COUNT ?
                                        <Button type="link" size="small" onClick={() => setShowAllEmails(!showAllEmails)}>
                                            {showAllEmails ? GetText("ReminderForm_ShowFewerEmails") : GetText("ReminderForm_ShowAllEmails") + " (" + reminderEmails.length + ")"}
                                        </Button> : null}
                                </div>
                            </Form.Item>

                            <Form.Item
                                name="Message"
                                label={GetText("ReminderForm_RemindersMessageFormText")}
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value != "") {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject(GetText("ReminderForm_RemindersMessageMandatoryText"));
                                            }
                                        }
                                    }
                                ]}
                            >
                                <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                                    <OneFrontHtmlEditor initialHtml={reminderText} hideVariablesMenu={true} onHtmlChange={(e: any) => setReminderText(e)} name="body" />
                                </Space>
                            </Form.Item>


                            <EventMailDesign onChange={setDesign} />

                            <Alert type="info" showIcon style={{ marginBottom: "20px", textAlign: "left" }} message={GetText("SendInviteForm_ReplyButtonInfo")} description={GetText("ReminderForm_ReplyButtonInfoDescription")} />

                            <Form.Item>
                                <Space wrap style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
                                    <EventMailActions eventId={props.event.eventId} isReminder={true} getMessage={() => reminderText} design={design} />
                                    <Button type="primary" htmlType="submit" disabled={reminderEmails.length === 0}>
                                        {GetText("ReminderForm_SendButtonText")}
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Form> </> : ""}

            </> : <span><Tag color="#1890ff">{GetText("Common_Subscription")}</Tag><a href={"/" + getCurrentLanguage() + "/Pricing"}>{GetText("Common_UpgradeToPremium")} </a>{GetText("ReminderForm_UpgradeToPremium")}</span>
        }
    </>
}